import loadable from "@loadable/component";
import StatusIcon from "../../Icons/StatusIcon";
import APIS from "../../constant/EndPoint";
import usePatchHook from "../../customHooks/usePatchHook";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import MerchantIcon from "../../Icons/MerchantIcon";
const MerchantListComponent = loadable(
  () => import("../../components/Merchant/MerchantList")
);

const MerchantList = () => {
  const { mutateAsync: patchUser } = usePatchHook({
    queryKey: ["merchant"],
    navigateURL: null,
  });

  const handleIsActive = async (value: boolean, id: any) => {
    const payload = {
      is_active: value,
    };
    const url = `${APIS.USER}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableEmail = async (value: boolean, id: any) => {
    const payload = {
      is_enable_email: value,
    };
    const url = `${APIS.MERCHANT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSenderEmail = async (value: boolean, id: any) => {
    const payload = {
      receive_email: value,
    };
    const url = `${APIS.MERCHANT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSMS = async (value: boolean, id: any) => {
    const payload = {
      is_enable_sms: value,
    };
    const url = `${APIS.MERCHANT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSenderSMS = async (value: boolean, id: any) => {
    const payload = {
      receive_sms: value,
    };
    const url = `${APIS.MERCHANT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  const handleIsEnableSummary = async (value: boolean, id: any) => {
    const payload = {
      is_summary_email: value,
    };
    const url = `${APIS.MERCHANT}${id}/`;
    const formData = payload;
    try {
      await patchUser({ url, formData });
    } catch (e) {
      console.log(e);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <MerchantIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Merchant</span>
      </div>
      <MerchantListComponent
        handleIsActive={handleIsActive}
        handleIsEnableEmail={handleIsEnableEmail}
        handleIsEnableSMS={handleIsEnableSMS}
        handleIsEnableSummary={handleIsEnableSummary}
        handleIsEnableSenderEmail={handleIsEnableSenderEmail}
        handleIsEnableSenderSMS={handleIsEnableSenderSMS}
      />
    </>
  );
};

export default MerchantList;
